import API from '@/models/API';

export default class StoreSubscriptions {
  constructor(item = {}) {}

  static get = (body) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/subscriptions${body.query}`);

  static updateSettings = (payload) =>
    API.patch(
      `/companies/${localStorage.getItem('storeId')}/subscriptions/${payload.id}/settings`,
      payload.body
    );

  static updateUnpaidSettings = (payload) =>
    API.patch(
      `/companies/${localStorage.getItem('storeId')}/subscriptions/store-subscription-settings/${payload.id}`,
      payload.body
    );
}
